// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TransactionPage.css */

/* 1. MAIN LAYOUT FIXES */
.transaction-page {
  font-family: 'Inter', sans-serif;
  padding: 24px; /* Essential for spacing from Sidebar/Topbar */
  width: 100%;
  box-sizing: border-box;
  background-color: #F9FAFB; /* Light background matching other pages */
  min-height: 0;
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 2. HEADER */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 24px;
}

.page-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #174078;
  margin: 0;
}

/* 3. CONTROLS (Right Side) */
.right-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Export Buttons */
.export-buttons {
  display: flex;
  gap: 10px;
}

.export-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.2s;
  height: 40px; /* Match search height */
}

.export-btn:hover {
  background-color: #F9FAFB;
  border-color: #F97316; /* Orange highlight on hover */
}

.export-btn img {
  height: 16px;
  width: 16px;
}

/* Search Bar */
.transaction-search-bar {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 0 12px;
  width: 280px;
  height: 40px;
}

.transaction-search-bar:focus-within {
  border-color: #F97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);
}

.transaction-search-bar img {
  height: 16px;
  opacity: 0.5;
  margin-right: 8px;
}

.transaction-search-bar input {
  border: none;
  outline: none;
  font-size: 14px;
  flex-grow: 1;
  background: transparent;
  color: #374151;
}

/* 4. TABS + DATE RANGE */
.filter-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;
  border-bottom: 1px solid #E5E7EB;
  margin-bottom: 24px;
}

.filter-tabs {
  display: flex;
  gap: 24px;
}

.date-range-filter {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding-bottom: 8px;
}

.date-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #6B7280;
}

.date-field input {
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 7px 10px;
  font-size: 13px;
  color: #374151;
  background-color: #fff;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.date-field input:focus {
  border-color: #F97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);
}

.date-clear-btn {
  border: 1px solid #E5E7EB;
  background-color: #fff;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.2s;
}

.date-clear-btn:hover {
  border-color: #F97316;
  color: #F97316;
}

.filter-tabs button {
  background: none;
  border: none;
  padding: 12px 4px;
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
}

.filter-tabs button:hover {
  color: #111827;
}

.filter-tabs button.active {
  color: #F97316; /* Active Orange */
  font-weight: 600;
}

.filter-tabs button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #F97316;
}

/* 5. TABLE */
.table-container {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  overflow-x: auto;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th {
  background-color: #F9FAFB;
  color: #6B7280;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  padding: 12px 24px;
  text-align: left;
  border-bottom: 1px solid #E5E7EB;
}

.data-table td {
  padding: 16px 24px;
  border-bottom: 1px solid #F3F4F6;
  font-size: 14px;
  color: #374151;
  white-space: nowrap;
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.action-icon {
  height: 18px;
  opacity: 0.7;
  cursor: pointer;
  transition: opacity 0.2s;
}

.action-icon:hover {
  opacity: 1;
}

/* 6. STATUS BADGES */
.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  display: inline-block;
  text-transform: capitalize;
}

.status-successful { background-color: #DEF7EC; color: #046C4E; }
.status-pending { background-color: #FEF3C7; color: #92400E; }
.status-failed { background-color: #FEE2E2; color: #991B1B; }
.status-unknown { background-color: #F3F4F6; color: #374151; }

/* 7. FOOTER */
.page-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  font-size: 14px;
  color: #6B7280;
}

.pagination-controls {
  display: flex;
  gap: 8px;
}

.pagination-controls button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.pagination-controls button:hover:not(:disabled) {
  border-color: #F97316;
}

.pagination-controls button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #F9FAFB;
}

.pagination-controls button img {
  height: 12px;
}

/* 8. EMPTY STATE */
.transaction-page--empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50vh;
  text-align: center;
}

.transaction-page--empty img {
  width: 80px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.transaction-page--empty h2 {
  font-size: 18px;
  font-weight: 500;
  color: #6B7280;
}

/* MESSAGES */
.table-message {
  text-align: center;
  padding: 40px;
  color: #6B7280;
  font-size: 14px;
}

.table-message.error {
  color: #DC2626;
}

@media (max-width: 768px) {
  .transaction-page .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .transaction-page .right-controls {
    width: 100%;
    flex-wrap: wrap;
  }

  .transaction-page .transaction-search-bar {
    max-width: 100%;
    flex: 1 1 100%;
  }

  .transaction-page .table-container {
    overflow-x: auto;
  }

  .transaction-page .filter-row {
    flex-direction: column;
    align-items: stretch;
  }

  .transaction-page .date-range-filter {
    flex-wrap: wrap;
  }

  .transaction-page .date-field {
    flex: 1 1 auto;
  }

  .transaction-page .date-field input {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TransactionPage/TransactionPage.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB,yBAAyB;AACzB;EACE,gCAAgC;EAChC,aAAa,EAAE,8CAA8C;EAC7D,WAAW;EACX,sBAAsB;EACtB,yBAAyB,EAAE,0CAA0C;EACrE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,YAAY,EAAE,wBAAwB;AACxC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB,EAAE,8BAA8B;AACvD;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,qBAAqB,yBAAyB,EAAE,cAAc,EAAE;AAChE,kBAAkB,yBAAyB,EAAE,cAAc,EAAE;AAC7D,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;AAC5D,kBAAkB,yBAAyB,EAAE,cAAc,EAAE;;AAE7D,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* TransactionPage.css */\n\n/* 1. MAIN LAYOUT FIXES */\n.transaction-page {\n  font-family: 'Inter', sans-serif;\n  padding: 24px; /* Essential for spacing from Sidebar/Topbar */\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #F9FAFB; /* Light background matching other pages */\n  min-height: 0;\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* 2. HEADER */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 24px;\n}\n\n.page-header h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #174078;\n  margin: 0;\n}\n\n/* 3. CONTROLS (Right Side) */\n.right-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Export Buttons */\n.export-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.export-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: #fff;\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  height: 40px; /* Match search height */\n}\n\n.export-btn:hover {\n  background-color: #F9FAFB;\n  border-color: #F97316; /* Orange highlight on hover */\n}\n\n.export-btn img {\n  height: 16px;\n  width: 16px;\n}\n\n/* Search Bar */\n.transaction-search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  padding: 0 12px;\n  width: 280px;\n  height: 40px;\n}\n\n.transaction-search-bar:focus-within {\n  border-color: #F97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);\n}\n\n.transaction-search-bar img {\n  height: 16px;\n  opacity: 0.5;\n  margin-right: 8px;\n}\n\n.transaction-search-bar input {\n  border: none;\n  outline: none;\n  font-size: 14px;\n  flex-grow: 1;\n  background: transparent;\n  color: #374151;\n}\n\n/* 4. TABS + DATE RANGE */\n.filter-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 16px;\n  border-bottom: 1px solid #E5E7EB;\n  margin-bottom: 24px;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 24px;\n}\n\n.date-range-filter {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  padding-bottom: 8px;\n}\n\n.date-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6B7280;\n}\n\n.date-field input {\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  padding: 7px 10px;\n  font-size: 13px;\n  color: #374151;\n  background-color: #fff;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.date-field input:focus {\n  border-color: #F97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);\n}\n\n.date-clear-btn {\n  border: 1px solid #E5E7EB;\n  background-color: #fff;\n  border-radius: 6px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6B7280;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.date-clear-btn:hover {\n  border-color: #F97316;\n  color: #F97316;\n}\n\n.filter-tabs button {\n  background: none;\n  border: none;\n  padding: 12px 4px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6B7280;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.2s;\n}\n\n.filter-tabs button:hover {\n  color: #111827;\n}\n\n.filter-tabs button.active {\n  color: #F97316; /* Active Orange */\n  font-weight: 600;\n}\n\n.filter-tabs button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #F97316;\n}\n\n/* 5. TABLE */\n.table-container {\n  background-color: #fff;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  overflow-x: auto;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table th {\n  background-color: #F9FAFB;\n  color: #6B7280;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  padding: 12px 24px;\n  text-align: left;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.data-table td {\n  padding: 16px 24px;\n  border-bottom: 1px solid #F3F4F6;\n  font-size: 14px;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.action-icon {\n  height: 18px;\n  opacity: 0.7;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.action-icon:hover {\n  opacity: 1;\n}\n\n/* 6. STATUS BADGES */\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  display: inline-block;\n  text-transform: capitalize;\n}\n\n.status-successful { background-color: #DEF7EC; color: #046C4E; }\n.status-pending { background-color: #FEF3C7; color: #92400E; }\n.status-failed { background-color: #FEE2E2; color: #991B1B; }\n.status-unknown { background-color: #F3F4F6; color: #374151; }\n\n/* 7. FOOTER */\n.page-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 20px;\n  font-size: 14px;\n  color: #6B7280;\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.pagination-controls button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  border: 1px solid #E5E7EB;\n  border-radius: 4px;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n}\n\n.pagination-controls button:hover:not(:disabled) {\n  border-color: #F97316;\n}\n\n.pagination-controls button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  background-color: #F9FAFB;\n}\n\n.pagination-controls button img {\n  height: 12px;\n}\n\n/* 8. EMPTY STATE */\n.transaction-page--empty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 50vh;\n  text-align: center;\n}\n\n.transaction-page--empty img {\n  width: 80px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.transaction-page--empty h2 {\n  font-size: 18px;\n  font-weight: 500;\n  color: #6B7280;\n}\n\n/* MESSAGES */\n.table-message {\n  text-align: center;\n  padding: 40px;\n  color: #6B7280;\n  font-size: 14px;\n}\n\n.table-message.error {\n  color: #DC2626;\n}\n\n@media (max-width: 768px) {\n  .transaction-page .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .transaction-page .right-controls {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .transaction-page .transaction-search-bar {\n    max-width: 100%;\n    flex: 1 1 100%;\n  }\n\n  .transaction-page .table-container {\n    overflow-x: auto;\n  }\n\n  .transaction-page .filter-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .transaction-page .date-range-filter {\n    flex-wrap: wrap;\n  }\n\n  .transaction-page .date-field {\n    flex: 1 1 auto;\n  }\n\n  .transaction-page .date-field input {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
